import { CreateSlice } from './index'

export type LocaisState = {
    locaisIds: number[]
    setLocaisIds: React.Dispatch<React.SetStateAction<number[]>>
}

export const createLocaisSlice: CreateSlice<LocaisState> = (set, get) => ({
    locaisIds: [],
    setLocaisIds: param => {
        const locaisIds =
            typeof param === 'function' ? param(get().locaisIds) : param
        set({ locaisIds })
    },
})
